import { Slide } from '@/types/slide';
import { gql } from '@apollo/client';

export interface GetLessonVariables {
    where: {
        id: string;
    };
}

export interface GetLessonResponse {
    lesson: {
        id: string;
        latestLessonDraft: {
            id: string;
            lessonName: string;
            dateUpdated: string;
            slides: Slide[];
        };
    };
}

export const GET_LESSON = gql`
    query Lesson($where: LessonWhereUniqueInput!) {
        lesson(where: $where) {
            id
            latestLessonDraft {
                id
                lessonName
                slides(orderBy: { sort: asc }) {
                    id
                    data
                    sort
                }
                dateUpdated
            }
        }
    }
`;
